// extracted by mini-css-extract-plugin
export default {"loader":"course_loader__iFGBQ","container":"course_container__8cvVt"};